<div class="w-full flex h-[100dvh] overflow-hidden">
  <div class="flex-1 bg-primary h-full hidden md:block">
    <div class="logo-section h-full flex items-center justify-center">
      <img width="284px" src="assets/images/icons/big-logo-white-2.svg" />
    </div>
  </div>
  <div class="flex-1 h-full overflow-auto bg-white">
    <div class="content-container mx-auto h-full py-2xl px-lg">
      <div class="mb-2xl flex md:hidden justify-center items-center">
        <img class="w-2/3" src="assets/images/icons/big-logo-with-title-2.svg" />
      </div>
      <router-outlet></router-outlet>
    </div>
  </div>
</div>
